import { FC, Fragment, PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { isCVSMobileApp } from '../lib/utils/utils';
import '../register-web-components';

interface Props {
  pageName?: string;
}

const Footer: FC<PropsWithChildren<Props>> = ({ children }): ReactElement => {
  const [isMobileAppView, setIsMobileAppView] = useState<boolean | undefined>(false);

  useEffect(() => {
    setIsMobileAppView(isCVSMobileApp()); // this is used to hide the global header for framed in mobile apps
  }, []);

  if (isMobileAppView) {
    return <Fragment>{children}</Fragment>;
  }

  return (
    <Fragment>
      <div>
        <cvs-footer-component />
        {children}
      </div>
    </Fragment>
  );
};

export default Footer;
